import { useSettings } from '../store/settings';
let ctx: AudioContext | null = null;
/** Short synthesized blips. Feed sounds are suppressed in scored rounds unless assisted audio is enabled. */
export function beep(kind: 'fill' | 'reject' | 'feed' | 'click' | 'win' | 'lose', scored = false) {
  const s = useSettings.getState(); if (!s.sound) return;
  if (kind === 'feed' && scored && !s.assistedAudio) return;
  try {
    ctx ??= new AudioContext();
    const o = ctx.createOscillator(), g = ctx.createGain();
    const f = { fill: 880, reject: 180, feed: 660, click: 1200, win: 990, lose: 220 }[kind];
    o.frequency.value = f; o.type = kind === 'reject' || kind === 'lose' ? 'sawtooth' : 'sine';
    g.gain.setValueAtTime(0.05, ctx.currentTime); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.12);
    o.connect(g).connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.13);
  } catch { /* audio unavailable */ }
}
